const getWindowOrigin = () => {
  if (typeof window === 'undefined' || !window.location) {
    return '';
  }
  return window.location.origin;
};

const getApiBaseUrl = () => {
  const envApiUrl = process.env.REACT_APP_API_URL;
  if (envApiUrl && envApiUrl.trim()) {
    return envApiUrl.trim().replace(/\/$/, '');
  }

  // Prefer relative API path for portability across environments.
  return '/api';
};

const getAppBaseUrl = () => {
  const envBaseUrl = process.env.REACT_APP_BASE_URL;
  if (envBaseUrl && envBaseUrl.trim()) {
    return envBaseUrl.trim().replace(/\/$/, '');
  }

  return getWindowOrigin();
};

export const RUNTIME_CONFIG = {
  API_BASE_URL: getApiBaseUrl(),
  APP_BASE_URL: getAppBaseUrl(),
  PANCHANG_API_PATH: (process.env.REACT_APP_PANCHANG_API_PATH || '/panchang/highlights').trim(),
  PANCHANG_PROVIDER_URL: (process.env.REACT_APP_PANCHANG_PROVIDER_URL || '').trim(),
  PANCHANG_API_KEY: (process.env.REACT_APP_PANCHANG_API_KEY || '').trim(),
  PANCHANG_ENABLE_FALLBACK: process.env.REACT_APP_PANCHANG_ENABLE_FALLBACK !== 'false',
  SHOW_DEV_NAV: process.env.NODE_ENV === 'development' && process.env.REACT_APP_SHOW_DEV_NAV === 'true',
  LEAD_CAPTURE_ENABLED: process.env.REACT_APP_ENABLE_FRONTEND_LEAD_CAPTURE !== 'false',
  LEAD_WEBHOOK_URL: (process.env.REACT_APP_LEAD_WEBHOOK_URL || '').trim(),
  NOTIFICATION_WEBHOOK_URL: (process.env.REACT_APP_NOTIFICATION_WEBHOOK_URL || '').trim(),
  LEAD_ADMIN_WHATSAPP: (process.env.REACT_APP_ADMIN_WHATSAPP || '').trim(),
  LEAD_DEFAULT_PANDIT_WHATSAPP: (process.env.REACT_APP_DEFAULT_PANDIT_WHATSAPP || '').trim(),
  LEAD_AUTO_OPEN_WHATSAPP: process.env.REACT_APP_LEAD_AUTO_OPEN_WHATSAPP !== 'false'
};

export default RUNTIME_CONFIG;
